import { CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import '@maersk-global/mds-components-core-textarea';
import { ButtonWithConfirmationComponent } from '../../shared-components/button-with-confirmation/button-with-confirmation.component';
import { AppSupportService } from '../../services/app-support.service';
import { ToastrService } from '../../services/toastr-service';
import { APICallStatus } from '../../models/api-call-status.mode';
import { ShopRequest } from '../../models/shop-request.model';
import { catchError, EMPTY } from 'rxjs';
import { ApplicationtTextService } from '../../services/application-text.service';
interface ShopRequestViewModel {
  code: string;
  status: string;
}

@Component({
  selector: 'app-shop',
  imports: [ButtonWithConfirmationComponent, RouterModule],
  templateUrl: './shop.component.html',
  styleUrl: './shop.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShopComponent {
  // Holds manually entered shop codes
  isRetriggerDisabled: boolean = false;
  shopData: ShopRequestViewModel[] = [];
  shopRequest: ShopRequestViewModel[] = [];
  uploadedFileName: string | null = null; // Stores the uploaded file's name
  fileContent: string = ''; // Stores the file's raw content
  shopApiCallStatus: APICallStatus = 'NOT_STARTED'; // Tracks the retrigger API call status

  constructor(
    private readonly appSupportService: AppSupportService,
    private readonly router: Router,
    private readonly toastrService: ToastrService,
    private readonly appTextService: ApplicationtTextService,
  ) {}

  onManualInput(event: Event): void {
    const inputElement = event.target as HTMLTextAreaElement;
    let manualShopCodes = inputElement?.value || ''; // Safely access the value property
    let shopCodes: string[] = [];
    if (manualShopCodes.trim()) {
      const latestManulShopCodes: string[] = manualShopCodes.split('\n').map((order: string) => order.trim());
      // Add the manually entered work orders to the existing list
      shopCodes = [...latestManulShopCodes];
    } else {
      shopCodes = [];
    }
    this.shopData = shopCodes.map((code) => {
      return {
        code: code,
        status: 'Not Started',
      };
    });
  }

  onActivateClicked(): () => void {
    return () => {
      this.isRetriggerDisabled = true;
      this.shopApiCallStatus = 'IN_PROGRESS';
      const shopRequests: ShopRequest[] = [];
      this.shopData.forEach((item, i) => {
        const shopRequest: ShopRequest = {
          maintenanceShopCode: item.code,
          isActive: true,
        };
        shopRequests.push(shopRequest);
      });

      // Update the API call status
      this.appSupportService
        .updateShopsStatus(shopRequests)
        .pipe(
          catchError((err) => {
            // Check if the error has the detailedErrors field
            if (err.error.detailedErrors && err.error.detailedErrors.length > 0) {
              // Find the error related to MaintenanceOrderNumbers
              const shopCodeError = err.error.detailedErrors.find((error: any) => error.field === 'MaintenanceOrderNumbers');
              const errorShopCode: Set<string> = new Set(shopCodeError.value.split(','));
              // Update the status of failed work orders
              this.shopData = this.shopData.map((item) => {
                if (errorShopCode.has(item.code)) {
                  return {
                    code: item.code,
                    status: 'Failed ' + err.error.errorMessage,
                  };
                } else {
                  return {
                    code: item.code,
                    status: 'Success',
                  };
                }
              });
              // If such an error exists, show the value in the toast
              if (shopCodeError) {
                this.toastrService.showToastr(`${err.error.errorMessage}: ${shopCodeError.value}`, 'error');
              }
            } else {
              // Default error message if detailed error is not present
              this.toastrService.showToastr(err.error.errorMessage, 'error');
            }
            this.shopApiCallStatus = 'FAILED'; // Update the API call status
            return EMPTY;
          }),
        )
        .subscribe((response) => {
          this.shopApiCallStatus = 'COMPLETED_SUCCESFULLY';
          this.shopData = this.shopData.map((item) => ({
            code: item.code,
            status: 'Success',
          }));
          if (response) {
            this.toastrService.showToastr(this.appTextService.allShopsUpdatedSuccessfully, 'success');
          } else {
            this.toastrService.showToastr(this.appTextService.shopCodeNotPresentInRecords, 'error');
          }
        });
    };
  }
}
